<template>
  <ui-input
    v-bind="$attrs"
    :type="type"
    class="ui-password"
    @click-right-icon="toggleType"
    v-on="$listeners"
    autocapitalize="off"
    spellcheck="false"
  >
    <template #addonRight>
      <ui-icon
        :name="type === 'password' ? 'eye-slash' : 'eye'"
        size="16"
      />
    </template>
  </ui-input>
</template>

<script>
export default {

  data() {
    return {
      type: 'password',
    };
  },

  methods: {
    toggleType() {
      if (this.type === 'password') {
        this.type = 'text';
      } else {
        this.type = 'password';
      }
    },
  },
};
</script>
